import { render, staticRenderFns } from "./UserSpark.vue?vue&type=template&id=82c4f7c8"
import script from "./UserSpark.vue?vue&type=script&lang=js"
export * from "./UserSpark.vue?vue&type=script&lang=js"
import style0 from "./UserSpark.vue?vue&type=style&index=0&id=82c4f7c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports